const MD_LINK_OR_URL_REGEX =
  /(\[[^\]]*\]\([^)]*\))|((?:https?:\/\/|w{3}\.)[\w-]+(?:\.[\w-]+)+(?:[\w.,@?^=%&:/~+#-]*))/g;

export const urlsToMdLinks = (str: string) =>
  str.replace(MD_LINK_OR_URL_REGEX, (match, mdLink: string | undefined) => {
    if (mdLink) return mdLink;
    const urlAddress = /^(https?|ftp):\/\//i.test(match) ? match : `//${match}`;
    return `[${match}](${urlAddress})`;
  });

export const isNDA = (value?: string | null) =>
  value?.trim().toLowerCase() === 'nda';
